import React, { useState } from 'react'
import { Typography, Button, Box, useTheme, useMediaQuery } from '@mui/material'

const ExpandableText = ({
  text,
  initialChars = 150,
  showFullText = false,
  color = 'text.secondary',
  variant = 'body1',
  buttonVariant = 'text',
  buttonColor = 'primary',
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [showAll, setShowAll] = useState(showFullText)

  const handleToggleText = () => {
    setShowAll(!showAll)
  }

  // Adjust initial characters for mobile
  const adjustedInitialChars = isMobile
    ? Math.floor(initialChars * 0.7)
    : initialChars

  const shouldTruncate = text.length > adjustedInitialChars && !showAll
  const displayText = showAll ? text : text.slice(0, adjustedInitialChars)

  return (
    <Box sx={{ mb: 1 }}>
      <Typography
        variant={variant}
        color={color}
        sx={{
          whiteSpace: 'pre-line', // Preserve line breaks
          wordBreak: 'break-word', // Prevent overflow
        }}
      >
        {displayText}
        {shouldTruncate && '...'}
      </Typography>

      {text.length > adjustedInitialChars && (
        <Button
          onClick={handleToggleText}
          variant={buttonVariant}
          color={buttonColor}
          size="small"
          sx={{
            mt: 0.5,
            ml: -1, // Align with text
            fontSize: '0.875rem',
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          {showAll ? 'Show Less' : 'Read More'}
        </Button>
      )}
    </Box>
  )
}

export default ExpandableText
